import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  territory: null,
  territories: null,
  duplicates: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const territoryReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.TERRITORY_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.TERRITORY_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.TERRITORY_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default territoryReducer;
